import { NavLink, Outlet } from "react-router-dom";
import Button from "../../components/ui/Button";
import FlowerTitle from "../../components/ui/FlowerTitle";
const System = () => { 

  return (
    <div className="page-container">
      
    <FlowerTitle text="System"/>
      <div className="page-nav">
        <NavLink to="combat">
          <Button text="Combat System" color="red"/>
        </NavLink>
        <NavLink to="leveling">
          <Button text="Leveling System" color="blue"/>
        </NavLink>
      </div>
      <Outlet/>
      <div className="page-nav">
        <NavLink to="combat">
          <Button text="Combat System" color="red"/>
        </NavLink>
        <NavLink to="leveling">
          <Button text="Leveling System" color="blue"/>
        </NavLink>
      </div>
    </div>
  )
}

export default System;